import { panelCellGroups } from "./panelTopology";

// Portrait coordinates: x increases to the right, y from the lower edge up.
// The same cell groups as the electrical model identify the section boundaries.
export function panelCellLines(topology, portrait = true) {
  if (!topology) return null;
  const rows = Number(topology.cellRows), columns = Number(topology.cellColumns);
  const groups = panelCellGroups(topology);
  if (!groups.length) return null;
  const byCell = new Map(groups.flatMap((group, index) => group.cells.map(cell => [cell, index])));
  const transform = (x, y) => portrait ? [x, y] : [y, 1 - x];
  const line = (x1, y1, x2, y2) => [transform(x1, y1), transform(x2, y2)];
  const grid = [], boundaries = [];
  for (let col = 1; col < columns; col++) grid.push(line(col / columns, 0, col / columns, 1));
  for (let row = 1; row < rows; row++) grid.push(line(0, row / rows, 1, row / rows));
  for (let row = 0; row < rows; row++) for (let col = 0; col < columns; col++) {
    const id = row * columns + col;
    if (col + 1 < columns && byCell.get(id) !== byCell.get(id + 1)) boundaries.push(line((col + 1) / columns, row / rows, (col + 1) / columns, (row + 1) / rows));
    if (row + 1 < rows && byCell.get(id) !== byCell.get(id + columns)) boundaries.push(line(col / columns, (row + 1) / rows, (col + 1) / columns, (row + 1) / rows));
  }
  return { grid, boundaries };
}
